/* eslint-disable react/style-prop-object */
import React from 'react';
import { FormattedNumber } from 'react-intl';

const Currency: React.FC<{ value: string | number }> = ({ value }) => (
  <FormattedNumber value={Number(value)} style="currency" currency="USD" />
);

export default Currency;
